<template>
  <div class="container type-range">
    <span class="value">
      <span :class="[digits >= 6 ? 'large' : digits >= 4 ? 'medium' : 'normal']"
        >{{ money(val) }}<span class="currency">{{ currency }}</span></span
      >
    </span>
    <strong class="unit">{{ data.longunit }}</strong>
    <!--template v-if="info">
      <span class="info value">{{ money(info.val) }}</span>
      <strong class="info unit">{{ info.longunit }}</strong>
    </template-->
    <div class="input-holder">
      <button class="minus" @click="minus">
        <img
          alt="minus"
          src="@/assets/minus.svg"
          width="25"
          height="25"
          title=""
        />
      </button>
      <label>
        <input
          type="range"
          ref="rangeInput"
          v-model.number="val"
          @input="changeValue"
          :name="data.name"
          :min="data.min"
          :max="data.max"
          :step="data.step"
        />
      </label>
      <button class="plus" @click="plus">
        <img
          alt="plus"
          src="@/assets/plus.svg"
          width="25"
          height="25"
          title=""
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Range",
  props: ["value", "data", "info", "currency"],
  data() {
    return {
      val: this.value || this.data.min,
      digits: 1
    };
  },
  /* computed: {
    digits(){
      console.log(this.val,' -> ',String(money(val)).length)
      return String(money(val)).length
    }
  }, */
  watch: {
    value(v) {
      this.val = v;
      this.setBackground();
    }
    /* "$store.state.answers"() {
      console.log("store change");
    }, */
  },
  mounted() {
    this.setBackground();
    this.changeValue();
  },
  methods: {
    money(m) {
      /* const str = Intl.NumberFormat("de-DE", {
        maximumSignificantDigits:5,
        style: "currency",
        currency: "EUR",
        currencyDisplay: "code",
      })
        .format(m)
        .replace("EUR", "")
        .trim(); */
      const str = String(m);
      this.digits = str.length;
      //console.log(str,' -> ',this.digits)
      return str;
    },
    setBackground() {
      const inp = this.$refs.rangeInput;
      const min = inp.min;
      const max = inp.max;

      inp.style.backgroundSize =
        ((this.val - min) * 100) / (max - min) + "% 100%";
    },
    changeValue() {
      this.$emit("input", this.val, this.data.name);

      if (this.data.slug === "meret") {
        let budget = this.$store.getters.getAnswerBySlug("budzse");
        if (budget) {
          let monthly = Math.ceil(budget.sqm * this.val * 10) / 10;
          this.$store.commit("setAnswerBySlug", {
            slug: "budzse",
            key: "monthly",
            value: monthly
          });
        }
      }
    },
    plus() {
      if (this.val < this.data.max) {
        this.val += this.data.step * 1;
        this.changeValue();
      }
    },
    minus() {
      if (this.val > this.data.min) {
        this.val -= this.data.step * 1;
        this.changeValue();
      }
    }
  }
};
</script>

<style lang="scss">
.type-range {
  display: flex;
  flex-direction: column;
  justify-content: space-between !important;

  .input-holder {
    border-radius: 0.6rem;
    background: $white;
    overflow: hidden;
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 16px;

    input {
      -webkit-appearance: none;
      appearance: none;
      outline: none !important;
      //width: 10rem;
      width: calc(100% - 30px);
      height: 4px;
      border-radius: 2px;
      background: $lightgray;
      background-image: linear-gradient($black, $black);
      background-size: 0% 100%;
      background-repeat: no-repeat;
      margin: 16px;
      padding: 0;
      overflow: visible;

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: $black;
        cursor: pointer;
      }

      &::-moz-range-thumb {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: $black;
        cursor: pointer;
      }
    }
    label {
      width: 100%;
    }
    button {
      position: relative;
      display: flex;
      border: 0;
      background: $white;
      padding: 0.8rem;
      cursor: pointer;

      img {
        width: 1.25rem;
        height: 1.25rem;
      }
      &:after {
        content: "";
        position: absolute;
        border-radius: 1px;
        left: 100%;
        top: 50%;
        width: 2px;
        height: 1.6rem;
        background: $lightgray;
        transform: translate(-50%, -50%);
      }
      &.plus {
        &:after {
          left: 0;
        }
      }
    }
  }
  .value {
    display: flex;
    font-family: $number;
    font-size: 140px;
    line-height: 160px;
    font-weight: 400;
    letter-spacing: -4px;
    color: $black;
    flex-grow: 1;
    align-items: center;
    .medium {
      font-size: 100px;
      letter-spacing: -4px;
    }
    .large {
      font-size: 90px;
      letter-spacing: -8px;
    }

    .currency {
      display: inline-block;
      font-size: 0.5em;
      line-height: 1em;
      //vertical-align: baseline;
    }
    &.info {
      font-size: 27px;
      line-height: 32px;
      font-weight: 400;
      padding-top: 8px;
    }
  }

  @media screen and (min-width: $breakpoint) {
    .input-holder {
      max-width: 345px;
    }
    .value {
      letter-spacing: 0;
      .medium {
        font-size: 140px;
        letter-spacing: 0;
      }
      .large {
        font-size: 140px;
        letter-spacing: 0;
      }
    }
  }
}
</style>
